import { render, staticRenderFns } from "./CelebrityTestimonials.vue?vue&type=template&id=7ec6b8f3&scoped=true&"
import script from "./CelebrityTestimonials.vue?vue&type=script&lang=ts&"
export * from "./CelebrityTestimonials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec6b8f3",
  null
  
)

export default component.exports